import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderDetailsInput } from './GetOrderDetailsInput';
import { GetOrderDetailsOutput } from './GetOrderDetailsOutput';

export class GetOrderDetailsService extends HttpServiceBase {

  handle = (input: GetOrderDetailsInput): Promise<Result<GetOrderDetailsOutput> | null> => {
    const promise = this.http.get<Result<GetOrderDetailsOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/details`);
    return promise;
  }
}